import { css } from '@emotion/react';

import { TOKEN, FONT_SIZE } from '~/configs/theme.ts';

interface ErrorPageProps {
  /** 에러 메시지 */
  message: string;
  /** HTTP 상태 코드 (선택) */
  status?: number;
  /** 에러 제목 (선택) */
  title?: string;
}

/**
 * 공용 에러 페이지 (Pure UI). RootBoundary / interruptWith 에서 사용.
 */
function ErrorPage({ message, status, title }: ErrorPageProps) {
  return (
    <div css={styles.wrap}>
      <span css={styles.emoji}>🐾</span>
      <h1 css={styles.title}>{title ?? (status ? `오류 ${status}` : '오류가 발생했습니다')}</h1>
      <p css={styles.message}>{message}</p>
      <a css={styles.link} href="/">
        홈으로 돌아가기
      </a>
    </div>
  );
}

const styles = {
  wrap: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    min-height: 100dvh;
    justify-content: center;
    padding: 40px 24px;
    text-align: center;
  `,
  emoji: css`
    font-size: 56px;
  `,
  title: css`
    margin: 8px 0 0;
    font-size: ${FONT_SIZE['20']};
    font-weight: 700;
    color: ${TOKEN.textPrimary};
  `,
  message: css`
    margin: 0 0 12px;
    color: ${TOKEN.textSecondary};
    font-size: ${FONT_SIZE['14']};
  `,
  link: css`
    color: ${TOKEN.primary};
    font-weight: 600;
    font-size: ${FONT_SIZE['14']};
  `,
};

export default ErrorPage;
